export default "__VITE_ASSET__66e1f705__"